import opsSettingsHeader from './opsSettingsHeader';

export default opsSettingsHeader;
